














import { Vue, Component, Prop } from 'vue-property-decorator';
import { Competency } from '@/models/competency/competency';

@Component({
  name: 'GJgrowEventCreateConfirmViewCompetency',
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateConfirmViewCompetency extends Vue {
  @Prop() title: string;
  @Prop() competencies: Competency[];
  mounted() {}
}
